import { useEffect, useRef } from "react";

/* Fuochi d'artificio su canvas: razzi che salgono ed esplodono
   in pioggia dorata, rosa e luna. Nessuna libreria, solo fisica. */
const COLORS = ["#e6b96f", "#d98a9e", "#f5ead2", "#9db4ff", "#ffd9a0"];

export const Fireworks = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const resize = () => {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
    };
    resize();
    window.addEventListener("resize", resize);

    const rand = (a, b) => a + Math.random() * (b - a);
    const rockets = [];
    const particles = [];

    const launch = () => {
      rockets.push({
        x: rand(0.12, 0.88) * canvas.width,
        y: canvas.height,
        vy: -rand(9.5, 12.5) * dpr,
        target: rand(0.16, 0.42) * canvas.height,
        color: COLORS[(Math.random() * COLORS.length) | 0],
      });
    };

    const explode = (r) => {
      const n = 76;
      for (let i = 0; i < n; i++) {
        const a = (Math.PI * 2 * i) / n + rand(-0.06, 0.06);
        const s = rand(1.4, 5.4) * dpr;
        particles.push({
          x: r.x,
          y: r.y,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s,
          life: 1,
          decay: rand(0.007, 0.015),
          color: Math.random() < 0.25 ? "#f5ead2" : r.color,
        });
      }
    };

    let launches = 0;
    launch();
    const launchTimer = setInterval(() => {
      launch();
      if (++launches >= 8) clearInterval(launchTimer);
    }, 460);

    let raf;
    let frames = 0;
    const loop = () => {
      frames++;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = rockets.length - 1; i >= 0; i--) {
        const r = rockets[i];
        r.y += r.vy;
        r.vy += 0.055 * dpr;
        ctx.globalAlpha = 1;
        ctx.fillStyle = r.color;
        ctx.beginPath();
        ctx.arc(r.x, r.y, 2 * dpr, 0, 7);
        ctx.fill();
        if (r.y <= r.target || r.vy > -1) {
          explode(r);
          rockets.splice(i, 1);
        }
      }

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.042 * dpr;
        p.vx *= 0.986;
        p.life -= p.decay;
        if (p.life <= 0) {
          particles.splice(i, 1);
          continue;
        }
        ctx.globalAlpha = Math.max(p.life, 0);
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, 1.8 * dpr, 0, 7);
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      if (rockets.length || particles.length || frames < 420) {
        raf = requestAnimationFrame(loop);
      }
    };
    raf = requestAnimationFrame(loop);

    return () => {
      clearInterval(launchTimer);
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fireworks"
      data-testid="fireworks"
      aria-hidden="true"
    />
  );
};
